import { Provider } from "@redotech/redo-order-common/provider";
import { productSourceToProvider } from "../product-source-provider";

export const MARKETPLACE_INVENTORY_PUSH_PROVIDERS = [Provider.SHOPIFY] as const;

export type MarketplaceInventoryPushProvider =
  (typeof MARKETPLACE_INVENTORY_PUSH_PROVIDERS)[number];

export const MARKETPLACE_INVENTORY_PUSH_PROVIDER_NAMES: Record<
  MarketplaceInventoryPushProvider,
  string
> = { [Provider.SHOPIFY]: "Shopify" };

export interface MarketplaceInventoryPushTargets {
  one: string;
  other: string;
  none: string;
}

export const MARKETPLACE_INVENTORY_PUSH_TARGETS: Record<
  MarketplaceInventoryPushProvider,
  MarketplaceInventoryPushTargets
> = {
  [Provider.SHOPIFY]: {
    one: "location",
    other: "locations",
    none: "this product isn't stocked at any Shopify location",
  },
};

const pushProviders: ReadonlySet<string> = new Set(
  MARKETPLACE_INVENTORY_PUSH_PROVIDERS,
);

export function isMarketplaceInventoryPushProvider(
  provider: Provider | null,
): provider is MarketplaceInventoryPushProvider {
  return provider !== null && pushProviders.has(provider);
}

export function marketplaceInventoryPushProviderForProductSource(
  source: string | null,
): MarketplaceInventoryPushProvider | null {
  const provider = productSourceToProvider(source);
  return isMarketplaceInventoryPushProvider(provider) ? provider : null;
}
